<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_24846_12152)">
      <path
        d="M14.6666 7.99999C14.6666 4.31809 11.6819 1.33332 7.99998 1.33332C4.31808 1.33332 1.33331 4.31809 1.33331 7.99999C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 7.99999Z"
        stroke="#214895"
      />
      <path
        d="M8.16148 11.3333V8.00001C8.16148 7.68574 8.16148 7.52861 8.06385 7.43097C7.96622 7.33334 7.80908 7.33334 7.49481 7.33334"
        stroke="#214895"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99468 5.33334H8.00067"
        stroke="#214895"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.33333"
      />
    </g>
    <defs>
      <clipPath id="clip0_24846_12152">
        <rect
          fill="white"
          height="16"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
</template>
